import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import EnvStore from '@store/env/EnvStore';
import AuthStore from 'stores/AuthStore';
import {LocalStorageKey} from '@store/@types/util/LocalStorageKey';
import {LoginError} from 'components/LoginError';
import {LoginErrorType} from 'stores/AuthStore.utils';

interface LoginErrorContainerProps {
  setCaptcha: (captcha: any) => void;
}

@connectToStores
class LoginErrorContainer extends React.PureComponent<
  LoginErrorContainerProps & ReturnType<typeof LoginErrorContainer.getPropsFromStores>
> {
  static getStores() {
    return [EnvStore, AuthStore];
  }

  static getPropsFromStores() {
    const siteKey = EnvStore.getState()[LocalStorageKey.CAPTCHA_SITE_KEY];
    const {loginError, failCount} = AuthStore.getState();
    return {siteKey, loginError, failCount};
  }

  componentDidUpdate(prevProps) {
    const needsCaptcha = this.props.loginError === LoginErrorType.NEEDS_CAPTCHA;
    const newFailure = this.props.failCount > prevProps.failCount;
    if (needsCaptcha && newFailure) {
      // Set null here to trigger submit button disable until a new value is set
      this.props.setCaptcha(null);
    }
  }

  render() {
    return <LoginError {...this.props} />;
  }
}

export default LoginErrorContainer as unknown as React.FC<LoginErrorContainerProps>;
